import React from 'react';

import { DutyHourTypeDynFlag } from 'generated';
import { useTranslation } from 'react-i18next';

import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const RosterplanRestrictedSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MultiStepForm.Section title={t('dutyHourTypes.section.rosterplan')}>
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="RESTRICTED_DUTY_TYPE"
        label={t('dutyHourTypes.fieldName.restrictedDutyType')}
      />
    </MultiStepForm.Section>
  );
};
